export const Features = () => {
  return (
    <div id="features">
      <div className="feature">
        <div className="container">
          <div className="row">

            <div className="col-md-3">
              <div className="feature-box">
                <img src="img/features/service1.png" alt="Servicing" />
                <p>SERVICING</p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="feature-box">
                <img src="img/features/icon2.png" alt="Installation" />
                <p>INSTALLATION</p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="feature-box">
                <img src="img/features/icon3.png" alt="Maintenance" />
                <p>MAINTENANCE</p>
              </div>
            </div>

            <div className="col-md-3">
              <div className="feature-box">
                <img src="img/features/icon4.png" alt="Repairs" />
                <p>REPAIRS</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};